import { useNavigate, useOutletContext } from 'react-router-dom'

import { EmployeeRouteMetaDocument, TerminatePageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'

import TerminateModal from '../components/Actions/TerminateModal'

const TerminatePage = () => {
  const { employee } = useOutletContext<{
    employee: Employee
  }>()

  const { data, client } = useQuery(TerminatePageDocument)
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const canSeeFormerEmployees = data?.employees._policies.seeFormerEmployees.can

  const navigationPath = canSeeFormerEmployees
    ? navigation.employees.id.fullPath({ id: employee.id })
    : navigation.employees.fullPath()

  const onSuccessTerminate = async () => {
    await Promise.all([memberships.fetch(), teams.fetch(), employees.fetch()])
    client.refetchQueries({ include: [EmployeeRouteMetaDocument] })
    navigate(navigationPath)
  }

  return (
    <TerminateModal
      employee={employee}
      onClose={() => navigate(navigation.employees.id.fullPath({ id: employee.id }))}
      onSuccess={() => onSuccessTerminate()}
      contractVersions={contractVersions}
    />
  )
}

export default TerminatePage
